import { AxiosInstance } from 'axios'

export type GetAllDecisionsArgs = {
  locale: string
}

export const getAllDecisions = async (client: AxiosInstance, { locale }: GetAllDecisionsArgs) => {
  const path = `/decisions`
  const params = {
    locale: locale,
    sort: { createdAt: 'asc' },
    fields: ['name'],
  }
  return (await client.get<{ data: Array<{ id: number; attributes: { name: string } }> }>(path, { params })).data.data
}
